<div class="container mt-4" style="background-color: white; border-radius: 20px">
  <div class="card" style="border-color: #6f42c1">
    <div class="card-header text-white bg-primary">Report Message</div>
    <div class="card-body">
      <form #reportForm="ngForm">
        <div class="mb-3">
          <label for="remarks" class="form-label">Remarks</label>
          <textarea [(ngModel)]="remark" id="remarks" class="form-control" rows="4" placeholder="Report Remarks(optional)" required name="remarks"></textarea>
        </div>

        <div class="form-check mb-3">
          <input [(ngModel)]="blockUser" type="checkbox" id="blockUser" class="form-check-input" name="blockUser" />
          <label class="form-check-label" for="blockUser">Block this user</label>
        </div>

        <button (click)="submitReport()" type="button" class="btn text-white" [ngClass]="{ 'btn-primary': !isHovered, 'btn-purple': isHovered }" (mouseover)="isHovered = true" (mouseout)="isHovered = false" [style.backgroundColor]="isHovered ? '#6f42c1' : '#6f42c1'">Submit Report</button>
      </form>
    </div>
  </div>
</div>
